import React from "react";

export const translationCroossZero = {
  ru: {
    statusDraw: "Ничья",
    statusPlay: "Ходит",
    statusWon: "выиграл",
    settingAgain: "Заново",
    settingHistoryHide: "Скрыть историю",
    settingHistoryShow: "Показать историю",
    historyTitle: "История",
    historyStart: "Перейти к началу",
    historyMove: "К ходу"
  },
  en: {
    statusDraw: "No one won",
    statusPlay: "Playing",
    statusWon: "won",
    settingAgain: "Again",
    settingHistoryHide: "Hide History",
    settingHistoryShow: "Show History",
    historyTitle: "History",
    historyStart: "Go to start",
    historyMove: "To step"
  },
};

export const TranslationCrossZeroContext = React.createContext();
